/**
 * 不回店统计分析
 */
import { NOTBACKSTATISTICS } from '../types';

export default {
    name: `${NOTBACKSTATISTICS}`,
    path: '/notBackStatistics',
    component: () => import(/* webpackChunkName: 'notBackStatistics' */ '@/views/notBackStatistics/'),
    redirect: { name: `${NOTBACKSTATISTICS}Index` },
    meta: {
        title: '不回店统计分析',
        savedPosition: { x: 0, y: 0 },
    },
    children: [
        {
            name: `${NOTBACKSTATISTICS}Index`,
            path: 'index',
            component: () => import(/* webpackChunkName: 'notBackStatistics' */ '@/views/notBackStatistics/home/Home.vue'),
        },

        // 二级页面示例, 没有二级页面就直接删掉
        // {
        //     name: `${NOTBACKSTATISTICS}Detail`,
        //     path: 'detail',
        //     component: () => import(/* webpackChunkName: 'notBackStatistics' */ '@/views/notBackStatistics/detail/Detail.vue'),
        // },
    ],
};
